<template>
  <datepicker
    ref="datepicker"
    :input-class="inputClass"
    :name="name"
    :required="required"
    v-model="date"
    :format="format"
    :clear-button="clearButton"
    :inline="inline"
    :placeholder="placeholder"
    :language="language"
    :monday-first="mondayFirst"
    :disabled-dates="state.disabledDates"
    :highlighted="state.highlighted"
    :initial-view="initialView"
    :minimum-view="minimumView"
    :maximum-view="maximumView"
    :calendar-class="calendarClass"
    @input="inputChanged"
  ></datepicker>
</template>

<script>
import { en, ru, ro } from "vuejs-datepicker/dist/locale";

export default {
  props: {
    initialDate: {
      default: null,
    },
    openDate: {
      default: null,
    },
    name: {
      default: "",
    },
    required: {
      default: true,
    },
    inline: {
      default: false,
    },
    mondayFirst: {
      default: true,
    },
    clearButton: {
      default: true,
    },
    format: {
      default: "yyyy-MM-dd",
    },
    dateFormat: {
      default: "yyyy-MM-dd",
    },
    inputClass: {
      default: "form-control bg-white",
    },
    locale: {
      default: "ro",
    },
    placeholder: {
      default: "",
    },
    disabledDates: {
      default: null,
    },
    highlighted: {
      default: null,
    },
    initialView: {
      default: null,
    },
    minimumView: {
      default: "day",
    },
    maximumView: {
      default: "year",
    },
    calendarClass: {
      default: null,
    },
    value: {
      default: null,
    },
  },

  data() {
    return {
      state: {
        disabledDates: this.disabledDates || {
          customPredictor: () => false,
        },
        highlighted: this.highlighted || {
          customPredictor: () => false,
        },
      },
      date: this.initialDate || this.openDate || this.value,
      language: this.locale == "en" ? en : this.locale == "ru" ? ru : ro,
    };
  },

  mounted() {
    console.log("DateInput Component Mounted.");
  },

  methods: {
    inputChanged(date) {
      this.$emit("input", date);
      setTimeout(() => {
        $(this.$refs.datepicker.$el)
          .find('[name="' + this.name + '"]')
          .trigger("change");
      }, 100);
    },
  },

  computed: {},

  watch: {
    openDate() {
      this.date = this.openDate;
    },

    value() {
      this.date = this.value;
    },
  },
};
</script>
<style>
.vdp-datepicker__calendar {
  z-index: 10000000;
  right: 0;
}

.vdp-datepicker__clear-button {
  position: absolute;
  right: 7px;
  top: 5px;
}
</style>
